import query from './APIServices'

interface CurrenciesData {
  id: number
  exchangeRate: number
  precissionAfterComma: number
  isActive: boolean
  isMain: boolean
  oficialExchangeRate: null
  currency: Currency
}

interface Currency {
  name: string
  code: string
}

export const getCurrencies = async () => {
  const response = await query.get('/administration/currency')
  const currenciesResponse = response?.data.items as CurrenciesData[]
  const currencies = currenciesResponse.map(
    (item) => item.currency
  ) as Currency[]
  return currencies
}
